import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { BACKEND_DATE_FORMAT } from '../../../config/helpers';
import jsonGet from '../../../util/jsonGet';

import { addCultureAndFallbackToParamsFromLocalStorage } from '../../../util/culture';
import {
  findCurrencyItemFromListWithFallback,
  getInitialCurrencyState,
} from '../../../util/currency';
import PromotedPackage from '../PromotedCarousel/PromotedPackage';
import CUSTOM_EVENT from '../../../util/customEvents';

const propTypes = {
  apiUrl: PropTypes.string.isRequired,
  compareCtaText: PropTypes.string.isRequired,
  ctaText: PropTypes.Array,
  destinations: PropTypes.Array,
  eventType: PropTypes.string,
  fromPriceText: PropTypes.string,
  includeSoldOutPackages: PropTypes.bool,
  limitedAvailabilityText: PropTypes.string,
  maxPrice: PropTypes.number,
  minPrice: PropTypes.number,
  perPersonText: PropTypes.string,
  siteKey: PropTypes.string.isRequired,
  soldOutText: PropTypes.string,
  tournaments: PropTypes.Array,
  waitingListText: PropTypes.string,
};

const defaultProps = {
  ctaText: '',
  destinations: [],
  eventType: '',
  fromPriceText: '',
  includeSoldOutPackages: true,
  limitedAvailabilityText: '',
  maxPrice: null,
  minPrice: null,
  perPersonText: '',
  soldOutText: '',
  tournaments: [],
  waitingListText: '',
};

class PackageListing extends Component {
  constructor(props) {
    super(props);

    this.handlePackagesApi = this.handlePackagesApi.bind(this);
    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);

    this.state = {
      items: [],
      currentCurrencyCodeAndSymbol: undefined,
    };
  }

  componentDidMount() {
    this.handlePackagesApi();
    window.addEventListener(CUSTOM_EVENT.CURRENCY_CHANGE, this.handleCurrencyChange);
  }

  componentWillUnmount() {
    window.removeEventListener(CUSTOM_EVENT.CURRENCY_CHANGE, this.handleCurrencyChange);
  }

  handleCurrencyChange(event) {
    const newCurrencyCode = event?.detail?.code;
    if (newCurrencyCode) {
      this.setState({ currentCurrencyCodeAndSymbol: event.detail });
    } else console.error('Currency data not found for:', newCurrencyCode);
  }

  handlePackagesApi() {
    const {
      apiUrl,
      destinations,
      eventType,
      includeSoldOutPackages,
      maxPrice,
      minPrice,
      siteKey,
      tournaments,
    } = this.props;

    const backendFriendlyDate = moment().format(BACKEND_DATE_FORMAT);

    const options = {};
    if (eventType !== '') options.eventType = eventType;
    options.siteKey = siteKey;
    options.page = 1;
    if (tournaments?.length !== 0) options.tournaments = tournaments;
    if (destinations?.length !== 0) options.destinations = destinations;
    if (maxPrice !== null) options.priceTo = maxPrice;
    if (minPrice !== null) options.priceFrom = minPrice;
    options.includeSoldOutPackages = includeSoldOutPackages;
    options.fromDate = backendFriendlyDate;

    const tourSearchApiRequestOptions = addCultureAndFallbackToParamsFromLocalStorage(options);

    jsonGet(
      apiUrl,
      tourSearchApiRequestOptions,
      (data) => {
        if (data.items.length > 0) {
          const currentCurrency = getInitialCurrencyState(data.items[0].pricePerCurrency);
          this.setState({
            currentCurrencyCodeAndSymbol: currentCurrency,
          });
        }
        this.setState({
          items: data.items,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  render() {
    const { items } = this.state;

    const { fromPriceText, limitedAvailabilityText, perPersonText, soldOutText, waitingListText } =
      this.props;

    return (
      <div className="PackageListingView">
        {items.length !== 0 && (
          <ul className="PackageListingView_content">
            {items.map((item) => {
              const currencyPriceSetting = findCurrencyItemFromListWithFallback(
                item.pricePerCurrency,
                this.state.currentCurrencyCodeAndSymbol.code
              );
              return (
                <li className="PackageListingView_column" key={item.id}>
                  <PromotedPackage
                    currencySymbol={this.state.currentCurrencyCodeAndSymbol.symbol}
                    compareCtaText={this.props.compareCtaText}
                    ctaText={this.props.ctaText}
                    date={item.date}
                    description={item.description}
                    fromPriceText={fromPriceText}
                    hasLimitedAvailability={item.limitedAvailability}
                    image={item.image}
                    inclusions={item.inclusions}
                    isSoldOut={item.isSoldOut}
                    tourKey={item.key}
                    limitedAvailabilityText={limitedAvailabilityText}
                    limitedAvailabilityTextOverride={item.limitedAvailabilityText}
                    limitedAvailabilityRemainingSpaces={item.limitedAvailabilityRemainingSpaces}
                    perPersonText={perPersonText}
                    price={currencyPriceSetting.totalPrice}
                    title={item.title}
                    soldOutText={soldOutText}
                    tournamentName={item.tournamentName}
                    url={item.url}
                    waitingListLink={item.waitingListLink}
                    waitingListText={waitingListText}
                  />
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }
}

PackageListing.propTypes = propTypes;
PackageListing.defaultProps = defaultProps;

export default PackageListing;
